import React from 'react';
import ReactQuill from 'react-quill';
// import DatePicker from 'react-datepicker';
import Dropdown from 'react-dropdown';
import { PostToggleCard, SelectTemplateCard, CtaLableCard, CustomWidthCard } from '../../components';


//for  
const toolbarModule = {
  container: [
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ]
};

const modulesQuill = {
  toolbar: toolbarModule
};

const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color',
];

let TimerAction = [
  { value: '1', label: 'Hide' },
  { value: '2', label: 'Restart' }
];


// let fontSize = [
//   { value: '10', label: '10px' },
//   { value: '12', label: '12px' },
//   { value: '13', label: '13px' },
//   { value: '14', label: '14px' },
//   { value: '16', label: '16px' },
//   { value: '18', label: '18px' },
//   { value: '20', label: '20px' },
//   { value: '22', label: '22px' },
//   { value: '24', label: '24px' },
//   { value: '26', label: '26px' },
//   { value: '28', label: '28px' },
// ];

let ddnFl = [];


let ddnSl = [];


let ddnTl = [];


const ToolLayoutCard = ({
  cnf,
  handleCnfChange,
  handleEditorFocus,
  arrLylt,
  currLayoutId,
  updateLayoutById,
  openIconModel,
  fnCheckFieldIsDisplayOrNot,
  currLayout,
  widgetType
}) => {

  if (widgetType == 'facebook_like') {
    ddnFl = [
      { value: 'standard', label: 'Standard' },
      { value: 'box_count', label: 'Box count' },
      { value: 'button_count', label: 'Button count' },
      { value: 'button', label: 'Button' }
    ];
    ddnSl = [
      { value: 'small', label: 'Small' },
      { value: 'large', label: 'Large' },
    ];
    ddnTl = [
      { value: 'like', label: 'Like' },
      { value: 'recommend', label: 'Recommend' },
    ];
  }

  if (widgetType == 'facebook_comments') {
    ddnFl = [
      { value: 'social', label: 'Top' },
      { value: 'reverse_time', label: 'Newest' },
      { value: 'time', label: 'Oldest' },
    ];

    ddnSl = [
      { value: '10', label: '10' },
      { value: '15', label: '15' },
      { value: '20', label: '20' },
      { value: '30', label: '30' },
      { value: '50', label: '50' },
    ];
  }

  if (widgetType == 'facebook_share') {
    ddnFl = [
      { value: 'box_count', label: 'Box count' },
      { value: 'button_count', label: 'Button count' },
      { value: 'button', label: 'Button' }
    ];

    ddnSl = [
      { value: 'small', label: 'Small' },
      { value: 'large', label: 'Large' },
    ];
  }

  return (
    <div className="tabs-layout-content">
      <SelectTemplateCard
        arrLylt={arrLylt}
        currLayoutId={currLayoutId}
        updateLayoutById={updateLayoutById} />

      {fnCheckFieldIsDisplayOrNot('header', currLayout) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Header</label>
            <div className="customize-list">
              {cnf && cnf.ihdr != undefined &&
                <PostToggleCard
                  className={'editor-toggle-contentwt editor-toggle-fullwt'}
                  ttl={'Show header'}
                  fieldName={'ihdr'}
                  value={cnf.ihdr}
                  handleCnfChange={handleCnfChange}>
                  {
                    cnf && cnf.ihdr == true &&
                    <div className="width10x">
                      {cnf.hdttxt != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title">
                          <label className="label-title">Title</label>
                          <ReactQuill value={cnf.hdttxt} className='editor-ckeditor-input hideEditor hdttxt' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('hdttxt', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('hdttxt');
                            }} />
                        </div>
                      }
                      {cnf.cptxt != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-caption">
                          <label className="label-title">Caption</label>
                          <ReactQuill value={cnf.cptxt} className='editor-ckeditor-input hideEditor cptxt' modules={modulesQuill} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('cptxt', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('cptxt');
                            }} />
                        </div>
                      }
                    </div>
                  }
                </PostToggleCard>

                // <div className="editor-toggle customize-dropdown toggle-header-dply">
                //   <label className="label-title">Show header</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.ihdr ? true : false} onChange={(e) => handleCnfChange('ihdr', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }

              {cnf && cnf.tlsfstln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">
                  <ReactQuill value={cnf.tlsfstln} className='editor-ckeditor-input hideEditor tlsfstln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlsfstln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlsfstln');
                    }} />
                </div>
              }
              {cnf && cnf.tlssndln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">

                  <ReactQuill value={cnf.tlssndln} className='editor-ckeditor-input hideEditor tlssndln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlssndln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlssndln');
                    }} />
                </div>
              }
              {cnf && cnf.tlstrdln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">

                  <ReactQuill value={cnf.tlstrdln} className='editor-ckeditor-input hideEditor tlstrdln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlstrdln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlstrdln');
                    }} />
                </div>
              }
              {cnf && cnf.tlsfrthln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">
                  <ReactQuill value={cnf.tlsfrthln} className='editor-ckeditor-input hideEditor tlsfrthln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlsfrthln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlsfrthln');
                    }} />
                </div>
              }
              {cnf && cnf.tlsffthln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">
                  <ReactQuill value={cnf.tlsffthln} className='editor-ckeditor-input hideEditor tlsffthln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlsffthln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlsffthln');
                    }} />
                </div>
              }
              {fnCheckFieldIsDisplayOrNot('cnf.tlssxtln', currLayout) && cnf && cnf.tlssxtln != undefined &&
                <div className="editor-input header-editor-ckeditor editor-header-title">
                  <ReactQuill value={cnf.tlssxtln} className='editor-ckeditor-input hideEditor tlssxtln tlsbg' modules={modulesQuill} formats={formatsQuill}
                    onChange={(newValue, delta, source) => {
                      if (source === 'user') {
                        handleCnfChange('tlssxtln', newValue);
                      }
                    }}
                    onFocus={() => {
                      handleEditorFocus('tlssxtln');
                    }} />
                </div>
              }
              {fnCheckFieldIsDisplayOrNot('cnf.tlsiicn', currLayout) && cnf && cnf.tlsiicn != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Icon display</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.tlsiicn} onChange={(e) => handleCnfChange('tlsiicn', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
              }
              {fnCheckFieldIsDisplayOrNot('cnf.tlsicn', currLayout) && cnf && cnf.tlsiicn == true && cnf.tlsicn != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                  <label className="label-title">Logo</label>
                  <div className="browse-upload-part">
                    <div className="browse-upload-show">
                      <img className="browse-upload-img" src={cnf.tlsicn} alt="image" />
                    </div>
                    <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('tlsicn')}>
                      <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                        <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                      </svg>
                    </label>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      {/* CTA lable */}
      {
        cnf && cnf.tlsibtn != undefined &&
        <CtaLableCard
          cnf={cnf}
          handleCnfChange={handleCnfChange}
          widgetType={widgetType} />
      }
      {/* for cookie consent widget */}
      {
        cnf && (cnf.ckcialwbtn != undefined || cnf.ckcidclnbtn != undefined) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Buttons</label>
            <div className="customize-list">
              <PostToggleCard
                className={'editor-toggle-contentwt editor-toggle-fullwt'}
                ttl={'Show allow button'}
                fieldName={'ckcialwbtn'}
                value={cnf.ckcialwbtn}
                handleCnfChange={handleCnfChange} >
                {cnf.ckcialwbtn == true &&
                  <div className="input-ctalabel input-ctalabel-dicsnt editor-input-fullwidth mt-2">
                    <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.ckcalwbtntxt} onChange={(e) => handleCnfChange('ckcalwbtntxt', e.target.value)} placeholder="Allow button text"></input>
                  </div>
                }
              </PostToggleCard>
              {/* <div className="editor-input editor-input-label">
                <div className="labeltgl-ctalabel mt-4 editor-input-fullwidth">
                  <label className="label-title">Show allow button</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.ckcialwbtn} onChange={(e) => handleCnfChange('ckcialwbtn', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>

              </div> */}
              <PostToggleCard
                className={'editor-toggle-contentwt editor-toggle-fullwt'}
                ttl={'Show decline button'}
                fieldName={'ckcidclnbtn'}
                value={cnf.ckcidclnbtn}
                handleCnfChange={handleCnfChange} >
                {cnf.ckcidclnbtn == true &&
                  <div className="input-ctalabel input-ctalabel-dicsnt editor-input-fullwidth mt-2">
                    <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.ckcdclnbtntxt} onChange={(e) => handleCnfChange('ckcdclnbtntxt', e.target.value)} placeholder="Decline button text"></input>
                  </div>
                }
              </PostToggleCard>
              {/* <div className="editor-input editor-input-label">
                <div className="labeltgl-ctalabel mt-4 editor-input-fullwidth">
                  <label className="label-title">Show decline button</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.ckcidclnbtn} onChange={(e) => handleCnfChange('ckcidclnbtn', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                {cnf.ckcidclnbtn == true &&
                  <div className="input-ctalabel input-ctalabel-dicsnt editor-input-fullwidth mt-2">
                    <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.ckcdclnbtntxt} onChange={(e) => handleCnfChange('ckcdclnbtntxt', e.target.value)} placeholder="Decline button text"></input>
                  </div>
                }
              </div> */}
            </div>
          </div>
        </div>
      }
      {
        cnf && cnf.tlsicntdwn != undefined &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Countdown</label>
            <div className="customize-list">
              <PostToggleCard
                className={'editor-toggle-contentwt editor-toggle-fullwt'}
                ttl={'Show countdown'}
                fieldName={'tlsicntdwn'}
                value={cnf.tlsicntdwn}
                handleCnfChange={handleCnfChange}>
                {cnf.tlsicntdwn == true &&
                  <div className="width10x">
                    <div className="mt-1">
                      <label className="label-title ">Start date</label>
                      <div className="editor-inputbtn editor-enter-datepk ">
                        {/* <DatePicker
                          selected={cnf.tlstmdr ? new Date(cnf.tlstmdr) : null}
                          onChange={date => handleCnfChange('tlstmdr', date)}
                          className={'editor-input-content editor-input-fullwidth  width10x'}
                          showTimeSelect
                          dateFormat="dd/MMM/yyyy h:mm aa" /> */}
                      </div>
                    </div>

                    <div className="mt-3">
                      <div className="editor-field-topline">
                        <label className="label-title">Evergreen countdown</label>
                        <label className="switch">
                          <input type="checkbox" checked={cnf.tlsitmevrgn} onChange={(e) => handleCnfChange('tlsitmevrgn', e.target.checked)} />
                          <span className="slider round"></span>
                        </label>
                      </div>
                      {cnf.tlsitmevrgn == true &&
                        <div className="">
                          <div className="editor-input header-editor-ckeditor editor-header-caption pb-0">
                            <div className="time-multi">
                              <div className="editor-input-timeago">
                                <input className="editor-input-content editor-input-tmmnt" type="text" value={cnf.tlstmevrgndd} onChange={(e) => handleCnfChange('tlstmevrgndd', e.target.value)} placeholder="Days"></input>
                              </div>
                              <div className="editor-input-timeago">
                                <input className="editor-input-content editor-input-tmhurs" type="text" value={cnf.tlstmevrgnhh} onChange={(e) => handleCnfChange('tlstmevrgnhh', e.target.value)} placeholder="Hours"></input>
                              </div>
                              <div className="editor-input-timeago">
                                <input className="editor-input-content editor-input-tmday" type="text" value={cnf.tlstmevrgnmm} onChange={(e) => handleCnfChange('tlstmevrgnmm', e.target.value)} placeholder="Minutes"></input>
                              </div>
                              <div className="editor-input-timeago">
                                <input className="editor-input-content editor-input-tmmnth" type="text" value={cnf.tlstmevrgnss} onChange={(e) => handleCnfChange('tlstmevrgnss', e.target.value)} placeholder="Seconds"></input>
                              </div>
                            </div>
                          </div>
                          <div className="editor-dropdown editor-dd-acafterex  editor-rowbdr-none p-0 m-0">
                            <label>Action after expiry</label>
                            <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={TimerAction} value={cnf.tlstmevrgnactn} onChange={(e) => handleCnfChange('tlstmevrgnactn', e.value)} />
                          </div>
                          {cnf.tlstmevrgnactn == '2' &&
                            <div className="editor-input editor-input-label editor-enter-date editor-enter-datest">
                              <div className="editor-input">
                                <label className="label-title">Restart after minutes</label>
                                <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlstmevrgnrstrt} onChange={(e) => handleCnfChange('tlstmevrgnrstrt', e.target.value)} placeholder="Restart after minutes"></input>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </PostToggleCard>
              {/* <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                <label className="label-title">Show countdown</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.tlsicntdwn} onChange={(e) => handleCnfChange('tlsicntdwn', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div> */}
            </div>
          </div>
        </div>
      }

      {/* Other */}
      {
        cnf && (currLayout.wln == 'facebook' || cnf.faqisrch != undefined || cnf.faqictrg != undefined) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Other</label>
            <div className="customize-list">
              {cnf.faqisrch != undefined &&
                <PostToggleCard
                  ttl={'Show search button'}
                  fieldName={'faqisrch'}
                  value={cnf.faqisrch}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Show search button</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.faqisrch} onChange={(e) => handleCnfChange('faqisrch', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }

              {/* for faq widget */}
              {cnf.faqictrg != undefined &&
                <PostToggleCard
                  ttl={'Show category'}
                  fieldName={'faqictrg'}
                  value={cnf.faqictrg}
                  handleCnfChange={handleCnfChange} />
                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Show category</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.faqictrg} onChange={(e) => handleCnfChange('faqictrg', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.faqifrstopn != undefined &&
                <PostToggleCard
                  ttl={'Default first open'}
                  fieldName={'faqifrstopn'}
                  value={cnf.faqifrstopn}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Default first open</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.faqifrstopn} onChange={(e) => handleCnfChange('faqifrstopn', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.faqialopn != undefined &&
                <PostToggleCard
                  ttl={'Default all open'}
                  fieldName={'faqialopn'}
                  value={cnf.faqialopn}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Default all open</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.faqialopn} onChange={(e) => handleCnfChange('faqialopn', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.faqimlyexpnd != undefined &&
                <PostToggleCard
                  ttl={'Expand multiple'}
                  fieldName={'faqimlyexpnd'}
                  value={cnf.faqimlyexpnd}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Expand multiple</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.faqimlyexpnd} onChange={(e) => handleCnfChange('faqimlyexpnd', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }

              {/* for facebook like share widget */}
              {cnf.fl != undefined &&
                <div className="editor-field-list">
                  <div className="editor-input header-editor-ckeditor editor-header-title editor-header-caption">
                    <label className="label-title">Page URL</label>
                    <input type='text'
                      className='editor-input-content editor-input-fullwidth'
                      placeholder='Enter facebook page URL'
                      onChange={(e) => handleCnfChange('fl', e.target.value)}
                      value={cnf.fl} />
                  </div>
                </div>
              }
              {cnf.ddnfl != undefined &&
                <div className="editor-dropdown">
                  {widgetType == 'facebook_comments' ?
                    <label>Order By</label>
                    :
                    <label>Layout</label>
                  }
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ddnFl} value={cnf.ddnfl} onChange={(e) => handleCnfChange('ddnfl', e.value)} />
                </div>
              }
              {cnf.ddnsl != undefined &&
                <div className="editor-dropdown">
                  {widgetType == 'facebook_comments' ?
                    <label>Number of posts</label>
                    :
                    <label>Size</label>
                  }
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ddnSl} value={cnf.ddnsl} onChange={(e) => handleCnfChange('ddnsl', e.value)} />
                </div>
              }

              {cnf.tglfl != undefined &&
                <PostToggleCard
                  ttl={'Show share button'}
                  fieldName={'tglfl'}
                  value={cnf.tglfl}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">Show share button</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.tglfl} onChange={(e) => handleCnfChange('tglfl', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.ddntl != undefined &&
                <div className="editor-dropdown">
                  <label>Type</label>
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ddnTl} value={cnf.ddntl} onChange={(e) => handleCnfChange('ddntl', e.value)} />
                </div>
              }
            </div>
          </div>
        </div>
      }

      {/* custom height / width */}
      {cnf && cnf.irspn != undefined &&
        <CustomWidthCard
          cnf={cnf}
          handleCnfChange={handleCnfChange} />
      }
    </div>
  );
};

export default ToolLayoutCard;


// WEBPACK FOOTER //
// ./src/components/Widget/ToolLayoutCard.js